"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var i18next = require("i18next");
var i18nextXhrBackend = require("i18next-xhr-backend");
var ICU = require("i18next-icu");
var stripJsonComments = require("strip-json-comments");
var ChainedBackend_1 = require("./ChainedBackend");
var DEFAULT_LANGUAGE = "en";
var DEFAULT_NS = "translation";
/**
 * Base LoomI18n class. This class wraps an underlying library that does the actual translation
 * with support to ICU Message Format. Must be initialized before using.
 */
var LoomI18n = /** @class */ (function () {
    function LoomI18n() {
        this.isInitialized = false;
        // Create a temporary instance until we are actually initialized
        this.i18n = i18next.createInstance();
        this.i18n.init();
    }
    /**
     * Initialize the instance. If no {@code initOptions} are provided, use sensible defaults.
     * @param initOptions The options to use when initializing the instance.
     */
    LoomI18n.prototype.init = function (initOptions) {
        if (initOptions === void 0) { initOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var bundledLanguages, i18nInitOptions;
            var _this = this;
            return __generator(this, function (_a) {
                // Create the instance that we will actually initialize. This allow calling init multiple times (if
                // user whant to re-initialize the instance), and allow us to initialize to a dummy instance in the
                // constructor above
                this.i18n = i18next.createInstance();
                // Setup the ICU (International Components for Unicode) message format
                // This is the module that support pluralization and formatting of numbers and dates.
                this.icu = new ICU({
                    formats: {
                        date: {
                            fullDateTime: {
                                weekday: "short",
                                month: "short",
                                day: "numeric",
                                year: "numeric",
                                hour: "numeric",
                                minute: "numeric",
                                second: "numeric",
                                timeZoneName: "short",
                                timeZone: "UTC"
                            }
                        }
                    }
                });
                this.bundledLocaleData = new Set();
                if (initOptions.localesData) {
                    Object.keys(initOptions.localesData).forEach(function (locale) {
                        _this.icu.addLocaleData(initOptions.localesData[locale]);
                        _this.bundledLocaleData.add(locale);
                    });
                }
                this.i18n.use(this.icu);
                bundledLanguages = Object.keys(initOptions.resources || {});
                i18nInitOptions = {
                    lng: initOptions.defaultLanguage || DEFAULT_LANGUAGE,
                    fallbackLng: bundledLanguages.concat([DEFAULT_LANGUAGE]),
                    defaultNS: DEFAULT_NS,
                    debug: false,
                    lowerCaseLng: false,
                    resources: adaptResources(initOptions.resources),
                    saveMissing: true
                };
                // Initialization is different depending if we have remote resources or not, so we need to branch on this.
                // The main difference is that when using remote file, we need to initialize without bundled resources first,
                // Then add the bundles. When using w/o remote resource, we initialize with the bundles directly
                if (initOptions.remoteResourcesPatterns) {
                    return [2 /*return*/, this.initWithBackend(initOptions, i18nInitOptions)
                            .then(function () {
                            _this.isInitialized = true;
                            _this.initCallback && _this.initCallback(i18nInitOptions.lng);
                        })
                            .catch(function (error) {
                            _this.initCallback && _this.initCallback(i18nInitOptions.lng, error);
                            throw error;
                        })];
                }
                else {
                    return [2 /*return*/, this.initWithBundle(initOptions, i18nInitOptions)
                            .then(function () {
                            _this.isInitialized = true;
                            _this.initCallback && _this.initCallback(i18nInitOptions.lng);
                        })
                            .catch(function (error) {
                            _this.initCallback && _this.initCallback(i18nInitOptions.lng, error);
                            throw error;
                        })];
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Initialize the instance synchronously. Can only be used when not using remote resources feature.
     * If no {@code initOptions} are provided, use sensible defaults.
     * @param initOptions same as @see InitOptions, but without `remoteResourcesPatterns`
     */
    LoomI18n.prototype.initSync = function (initOptions) {
        if (initOptions === void 0) { initOptions = {}; }
        this.init(initOptions);
    };
    LoomI18n.prototype.initWithBackend = function (initOptions, i18nInitOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var backendChain;
            var _this = this;
            return __generator(this, function (_a) {
                // Prevent remote loading of resources already bundled
                i18nInitOptions.partialBundledLanguages = true;
                backendChain = new ChainedBackend_1.default(initOptions.remoteResourcesPatterns.map(function (remoteResourcesPattern) {
                    return new i18nextXhrBackend(null, {
                        loadPath: remoteResourcesPattern,
                        parse: function (data) { return JSON.parse(stripJsonComments(data)); }
                    });
                }));
                this.i18n.use(backendChain);
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.i18n
                            .init(i18nInitOptions, function (err) {
                            // Only propagate the error if we do not have resources for the default language
                            if (err && !initOptions.resources) {
                                reject(err);
                            }
                            resolve();
                        });
                    })];
            });
        });
    };
    LoomI18n.prototype.initWithBundle = function (initOptions, i18nInitOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var res, rej, p;
            return __generator(this, function (_a) {
                // Setting this flag allow init to be synchronous, which is ok in this case since we do not have remote
                // resources to fetch.
                i18nInitOptions.initImmediate = false;
                p = new Promise(function (resolve, reject) {
                    res = resolve;
                    rej = reject;
                });
                this.i18n
                    .init(i18nInitOptions, function (err) {
                    // Only propagate the error if we do not have resources for the default language
                    if (err &&
                        (!initOptions.resources || !i18nInitOptions.lng || !initOptions.resources[i18nInitOptions.lng])) {
                        rej(err);
                    }
                    res();
                });
                return [2 /*return*/, p];
            });
        });
    };
    /**
     * Change the language of the current instance.
     * @param language New language to use. Can be either language code (e.g. "en"), or locale code (e.g. "en-US"))
     */
    LoomI18n.prototype.changeLanguage = function (language) {
        return __awaiter(this, void 0, void 0, function () {
            var languageCode, localeDataPromise, changeLanguagePromise;
            var _this = this;
            return __generator(this, function (_a) {
                languageCode = language.split("-")[0];
                localeDataPromise = Promise.resolve();
                // If we are running inside a broswer, we need to dynamically load the locale-data to get proper
                // localization of plurals, dates and times.
                if (window && window.document && window.document.createElement) {
                    localeDataPromise.then(function () { return new Promise(function (resolve) {
                        // Check if the language data was loaded on init
                        if (_this.bundledLocaleData.has(languageCode)) {
                            return resolve();
                        }
                        // Check if we already loaded the locale data
                        var reactIntlLocaleData = window.ReactIntlLocaleData;
                        if (reactIntlLocaleData && reactIntlLocaleData[languageCode]) {
                            return resolve();
                        }
                        // Check if we already added the script to the page
                        var id = "loomi18n-locale-data-" + language;
                        if (window.document.getElementById(id)) {
                            return resolve();
                        }
                        var localeDataScript = window.document.createElement("script");
                        localeDataScript.id = id;
                        localeDataScript.async = true;
                        localeDataScript.src = "https://plugins.oci.oraclecloud.com/locales/locale-data/" + languageCode + ".js";
                        localeDataScript.onload = function () {
                            // We need to re-read the object from window here, as it may not have existed previously
                            var reactIntlLocaleData = window.ReactIntlLocaleData;
                            if (reactIntlLocaleData && reactIntlLocaleData[languageCode]) {
                                _this.icu.addLocaleData(window.ReactIntlLocaleData[languageCode]);
                            }
                            else {
                                console.warn("Loaded locale-data script for languageCode " + languageCode + " did not provide corresponding locale-data");
                            }
                            return resolve();
                        };
                        localeDataScript.onerror = function (err) {
                            // We should not crash if we cannot load locale-data
                            console.warn("Error while loading locale-data script for languageCode " + languageCode + ":", err);
                            return resolve();
                        };
                        window.document.body.appendChild(localeDataScript);
                    }); });
                }
                changeLanguagePromise = new Promise(function (resolve) {
                    _this.i18n.changeLanguage(language, function (err) {
                        // Only log and warning if language change failed, since it will fallback to default anyway
                        if (err) {
                            console.warn("changeLanguage", err);
                        }
                        resolve();
                    });
                });
                return [2 /*return*/, Promise.all([localeDataPromise, changeLanguagePromise])
                        .then(function () {
                        _this.changeLanguageCallback && _this.changeLanguageCallback(language);
                    })
                        .catch(function (_a) {
                        var localeDataError = _a[0], changeLanguageError = _a[1];
                        if (localeDataError) {
                            console.error("Could not load required locale-data", localeDataError);
                        }
                        if (changeLanguageError) {
                            console.error("Error while trying to change language", changeLanguageError);
                        }
                        _this.changeLanguageCallback && _this.changeLanguageCallback(language, localeDataError || changeLanguageError);
                        throw (localeDataError || changeLanguageError);
                    })];
            });
        });
    };
    /**
     * Add a notification callback on change of language. Useful for applications that may need
     * to do work once the language is changed (e.g. forceUpdate of the root component in react).
     * Do not call this method before you called @method init
     * @param callback
     */
    LoomI18n.prototype.onLanguageChanged = function (callback) {
        this.changeLanguageCallback = callback;
    };
    // tslint:disable-next-line function-name
    LoomI18n.prototype.t = function (key, args) {
        return this.i18n.t(key, args);
    };
    /**
     * Add a notification callback on missing translation key. Useful for applicatons that may need to do
     * work once the translation key is missing in translation files.
     * Do not call this method before you called @method init
     * @param callback
     */
    LoomI18n.prototype.onMissingKey = function (callback) {
        this.i18n.on("missingKey", function (_, __, key) {
            callback(key);
        });
    };
    /**
     * If set before you call @method init this callback would be called.
     * @param callback
     */
    LoomI18n.prototype.onInit = function (callback) {
        this.initCallback = callback;
    };
    return LoomI18n;
}());
exports.LoomI18n = LoomI18n;
function adaptResources(resources) {
    var i18nextResource = {};
    if (resources) {
        Object.keys(resources).forEach(function (key) {
            var _a;
            i18nextResource[key] = (_a = {},
                _a[DEFAULT_NS] = resources[key],
                _a);
        });
    }
    return i18nextResource;
}
//# sourceMappingURL=LoomI18n.js.map